import { useVariant } from '@unleash/proxy-client-react';
import { UnleashInvestorPortalFlag } from 'config/unleash/unleash-feature-toggle-flag';
import { useCallback, useMemo } from 'react';
import { isIssuerInBlockedList, parseBlockedIssuerIds } from 'shared/util/investor-portal-blocked-issuers-utils';

const useInvestorPortalBlockedIssuers = () => {
    const { enabled, payload } = useVariant(UnleashInvestorPortalFlag.BLOCKED_ISSUERS);

    const blockedIssuerIds = useMemo(
        () => parseBlockedIssuerIds(enabled === true, payload?.value),
        [enabled, payload]
    );

    const isIssuerBlocked = useCallback((issuerId: string) => isIssuerInBlockedList(blockedIssuerIds, issuerId), [blockedIssuerIds]);

    return { isIssuerBlocked, blockedIssuerIds };
};

export default useInvestorPortalBlockedIssuers;
